import store from 'store';
import Acl from './acl';
import accessControlWrapper from './access-control';

const AclService = new Acl(store);
const accessControl = accessControlWrapper(AclService);

export default AclService;
export { accessControl };
